var MOBILE_VIEWPORT_WIDTH = 768;
var DEBOUNCE_DELAY = 200;
var TOUCH_SENSITIVITY_THRESHOLD = 30;

function toggleActiveDot(dotIndex, dotsContainer) {
    var activeDot = dotsContainer.querySelector(".active");
    if (activeDot) activeDot.classList.remove("active");
    var newActiveDot = dotsContainer.querySelector("[data-index='" + dotIndex + "']");
    if (newActiveDot) newActiveDot.classList.add("active");
}

function debounce(func, delay) {
    var timeout;
    return function() {
        var args = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(function() {
            func.apply(null, args);
        }, delay);
    };
}

function hideButton(button, condition) {
    button.style.display = condition ? "none" : "";
}

function isDesktop() {
    return window.innerWidth >= MOBILE_VIEWPORT_WIDTH;
}

function createDotsForSlider(slider, prevButton, nextButton) {
    var sliderItems = Array.from(slider.querySelectorAll(".slider__item"));

    if (!sliderItems.length) {
        console.error("El slider o sus elementos no están presentes en el DOM.");
        return;
    }

    var dotsContainer = slider.parentElement.querySelector(".dots-container");
    if (!dotsContainer) {
        dotsContainer = document.createElement("div");
        dotsContainer.className = "dots-container";
        slider.insertAdjacentElement("afterend", dotsContainer);
    }

    var currentSlide = 0;
    var slidesToShowMobile = 2;
    var slidesToShowDesktop = parseInt(slider.getAttribute("data-slides-to-show-desktop"), 10) || slidesToShowMobile;
    var slidesToShow = slidesToShowMobile;

    var xDown = null;
    var yDown = null;

    var maxSlideIndex = function() {
        return Math.floor((sliderItems.length - 1) / slidesToShow);
    };
    var itemWidth = function() {
        return slider.parentElement.offsetWidth / slidesToShow;
    };

    function updateSlidesToShow() {
        slidesToShow = isDesktop() ? slidesToShowDesktop : slidesToShowMobile;
        sliderItems.forEach(function(item) {
            item.style.width = itemWidth() + "px";
        });
        checkButtonVisibility();
    }

    function createDots() {
        dotsContainer.innerHTML = '';
        if (sliderItems.length > slidesToShow) {
            var dotsCount = Math.ceil(sliderItems.length / slidesToShow);
            var fragment = document.createDocumentFragment();

            for (var i = 0; i < dotsCount; i++) {
                var dot = document.createElement("span");
                dot.className = "dot";
                dot.dataset.index = i;
                dot.addEventListener("click", function() {
                    currentSlide = parseInt(this.dataset.index, 10);
                    updateSliderPosition();
                    toggleActiveDot(currentSlide, dotsContainer);
                });
                fragment.appendChild(dot);
            }

            dotsContainer.appendChild(fragment);
            toggleActiveDot(currentSlide, dotsContainer);
        }
    }

    function updateSliderPosition() {
        var targetSlide = currentSlide * slidesToShow;
        var remainingItems = sliderItems.length - targetSlide;
        if (remainingItems < slidesToShow && remainingItems > 0) {
            var finalPosition = (targetSlide + remainingItems - slidesToShow) * (100 / slidesToShow);
            slider.style.transform = "translateX(-" + finalPosition + "%)";
        } else {
            slider.style.transform = "translateX(-" + targetSlide * (100 / slidesToShow) + "%)";
        }
    }

    function handleTouchStart(event) {
        xDown = event.touches[0].clientX;
        yDown = event.touches[0].clientY;
    }

    function handleTouchMove(event) {
        if (!xDown || !yDown) return;

        var xUp = event.touches[0].clientX;
        var yUp = event.touches[0].clientY;

        var xDiff = xDown - xUp;
        var yDiff = yDown - yUp;

        if (Math.abs(xDiff) > Math.abs(yDiff) && Math.abs(xDiff) > TOUCH_SENSITIVITY_THRESHOLD) {
            if (xDiff > 0) {
                changeSlide(1);
            } else {
                changeSlide(-1);
            }
            xDown = null;
            yDown = null;
        }
    }

    function changeSlide(direction) {
        var newSlide = currentSlide + direction;
        if (newSlide > maxSlideIndex()) {
            currentSlide = maxSlideIndex();
        } else if (newSlide < 0) {
            currentSlide = 0;
        } else {
            currentSlide = newSlide;
        }

        updateSliderPosition();
        toggleActiveDot(currentSlide, dotsContainer);
        checkButtonVisibility();
    }

    function checkButtonVisibility() {
        var atStart = currentSlide === 0;
        var atEnd = currentSlide >= Math.ceil((sliderItems.length - slidesToShow) / slidesToShow);
        if (sliderItems.length <= slidesToShow) {
            hideButton(prevButton, true);
            hideButton(nextButton, true);
        } else {
            hideButton(prevButton, atStart);
            hideButton(nextButton, atEnd);
        }
    }

    prevButton.addEventListener("click", function() { changeSlide(-1); });
    nextButton.addEventListener("click", function() { changeSlide(1); });
    slider.addEventListener("touchstart", handleTouchStart, { passive: true });
    slider.addEventListener("touchmove", handleTouchMove, { passive: true });

    window.addEventListener(
        "resize",
        debounce(function() {
            var dotsCountOld = Math.ceil(sliderItems.length / slidesToShow);
            updateSlidesToShow();
            var dotsCountNew = Math.ceil(sliderItems.length / slidesToShow);
            if (dotsCountOld !== dotsCountNew) {
                currentSlide = Math.floor(currentSlide * dotsCountOld / dotsCountNew);
            }
            updateSliderPosition();
            createDots();
        }, DEBOUNCE_DELAY)
    );

    updateSlidesToShow();
    updateSliderPosition();
    createDots();
}

document.querySelectorAll('.slider-container').forEach(function(sliderContainer) {
    var slider = sliderContainer.querySelector('ul.slider');
    var prevButton = sliderContainer.querySelector(".slider-button--prev");
    var nextButton = sliderContainer.querySelector(".slider-button--next");
    if (slider && prevButton && nextButton) {
        createDotsForSlider(slider, prevButton, nextButton);
    }
});
